<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Paparan Resit Ibayaq" >

      
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitResit" @success="onSuccess">
    <w-card bg-color="" class="">
        <w-flex justify-center align-center>
          <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No Resit :
                  </h5>
                  <div class="fw-normal my1 fs-1">{{form.no_resit}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Resit :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.tarikh_bayaran}} </div>
            </div>
            <div class="xs4">
                <h5 class="fw-semibold m0">
                      Status Resit:
                </h5>
                <div class="fw-normal my1 fs-1">
                    <template v-if="form.status == 1">
                        Bayar
                    </template>
                    <template v-else>
                        Batal
                    </template>
                </div>
            </div>
            
        </w-flex>
        <w-flex justify-center align-center>
          <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No Cek/Bank Deraf :
                  </h5>
                  <div class="fw-normal my1 fs-1"> </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Nama :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.pemilik_nama}}</div>
            </div> 
            <div class="xs4">
                 <h5 class="fw-semibold m0">
                      No Rujukan :
                  </h5>
                  <div class="fw-normal my1 fs-1">{{form.no_rujukan}} </div>
              
            </div>
        </w-flex>
        <w-flex justify-left align-center>
          <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Alamat :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.alamat1}}
                    <template v-if="form.alamat2"> , </template> {{form.alamat2}}
                    <template v-if="form.alamat3"> , </template> {{form.alamat3}}
                    <template v-if="form.poskod"> , </template> {{form.poskod}}
                    <template v-if="form.bandar"> , </template> {{form.bandar}}
                    <template v-if="form.negeri"> , </template> {{form.negeri}}</div>
            </div> 
            <div class="xs4">
                <template v-if="form.status !=1 ">
                    <h5 class="fw-semibold m0">
                          Status Penyesuaian :
                    </h5>
                    <div class="fw-normal my1 fs-1">
                        <template v-if="form.penyesuaian_status == 1">
                            SEPADAN
                        </template>
                        <template v-else-if="form.penyesuaian_status == 2">
                            TIDAK SEPADAN
                        </template>
                        <template v-else-if="form.penyesuaian_status == 3">
                           BELUM DIPROSES
                        </template>
                        <template v-else-if="form.penyesuaian_status == 4">
                           BATAL
                        </template>
                        <template v-else>

                        </template>
                    </div>
                </template>
            </div>

            <div class="xs4">
                <template v-if="form.status !=1 ">
                  <h5 class="fw-semibold m0">
                      Ulasan Batal :
                  </h5>
                  <div class="fw-normal my1 fs-1">{{form.ulasan_batal}} </div>
                </template>
            </div>
            
           
          </w-flex>
    </w-card>

    

    <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
    <template #item-content.1> 

              <w-flex justify-center align-center class="mt5">
              <div class="w-card__content content-hardcode">                
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td>KOD HASIL</td>
                            <td>BUTIRAN</td>
                            <td>AMAUN BAYARAN (RM)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dt, index in form.butiran">
                            <td >
                                <template v-if="dt.detail.kod_hasil">
                                    {{dt.detail.kod_hasil}}
                                </template>
                                <template v-else>
                                    {{dt.detail.IC_BARU}}
                                </template>
                                <!-- {{dt.akaun_kod}} | {{dt.akaun_keterangan}} -->
                            </td>
                             <td >
                                     {{dt.keterangan}}
                            </td>
                            <td align="right">
                                {{$zutil.currency(dt.amaun)}}
                            </td>
                           
                        </tr>
                        <tr >
                          <td colspan="2" align="right"><b>Jumlah</b></td>
                          <td align="right"><b>{{$zutil.currency(form.amaun_butiran)}}</b></td>
                          
                          <!-- <td>{{$zutil.currency(form.kuantiti)}}</td> -->
                        </tr>
                        
                        
                    </tbody>
                </table>
              </div>

            </w-flex>
             <w-flex class="mt3" wrap align-center justify-end>
                     <w-button class="my1" bg-color="warning" dark  @click="kembali()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Kembali
                    </w-button>
                    &nbsp;&nbsp;
                    <template  v-if="form.status == 1 && $zutil.can('Resit Batal')">
                        <w-button class="my1" bg-color="error-dark1" dark  @click="BatalResit()" >
                             <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                        </w-button>
                        &nbsp;
                    </template>
                   <!--  <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak Salinan
                    </w-button>
                    &nbsp; -->
                    <!-- <w-button bg-color="success" class="mr3" @click="cetak_pejabat()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak Salinan Pejabat
                    </w-button> -->
            </w-flex>
        </template>
        <template #item-content.2>
                    <w-flex justify-center align-center>
                      <div class="w-card__content content-hardcode">

                          <table class="table-dashboard" width="100%">
                              <thead>
                              <tr>
                                  <td >No</td>
                                  <td >Tindakan</td>
                                  <td >Pengguna</td>
                                  <td >Tarikh</td>
                                  <td>Catatan</td>
                              </tr>
                              </thead>
                              <tbody>
                              
                                  <tr v-for="dt, index in audit">
                                      <td class="w-table__cell text-left">
                                          {{(index + 1)}}
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{dt.tindakanResit.keterangan}}
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{ dt.user.name }}
                                      </td>
                                      <td class="w-table__cell text-left">
                                           {{$zutil.dateformat(dt.created_at)}} 
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{dt.catatan}}
                                      </td>
                                  </tr>
                                
                              </tbody>
                              
                          </table>
                        </div>
                      </w-flex>
        </template>

    </w-tabs>
             

        </w-form>

     
     
  
    </z-page>
    <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Permohonan Batal Resit
            </template>
            <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess"> 
               <w-flex justify-space-between class="mb4">
                   <z-input 
                        label="Catatan Batal *"  
                        name="catatan_batal" 
                        v-model="form.ulasan_batal"
                        :validators="[validators.required]"/>
              </w-flex>
            </w-form>
            

            <template #actions>
                <div class="spacer" />
                  <w-button class="my1" bg-color="primary"  dark :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(2)" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Hantar
                  </w-button>
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
    resourceurl: this.service_ibayaq +'resit_ibayaq',
    reload: true,
          form: {
                    lkp_bank_id : '',
                },
    dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },


         validators: {
                unique: (value) => !!value || "Medan Ini Wajib Isi",
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },

      
    
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Resit', route: '/resit' },
        { label: 'Papar Ibayaq', route: '/resit/show_ibayaq'+this.id },
      ],
       tabs: [
          { title: 'Senarai Butiran', content: '' },
          { title: 'Jejak Audit', content: '' },
      ],
    }
  },
    methods: {

   

    send(status){

     // alert(status);
      this.form.status = status
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
        // this.$zcomm.post(this.service_ibayaq+'edit/'+this.id, this.form_batal)
                  .then(res => {

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                        this.$inertia.visit(this.$route('kutipan.resit.ibayaq'))
                        this.janaJejakAudit();
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    },

    // cetak(id) {
    //         // window.location.href = this.service_bil_pelbagai+'api/inbois/cetak'+id;
    //         window.location.href = this.service_ibayaq+'cetak_resit/'+this.id;
    //     },
  
        kembali(){
             this.$inertia.visit(this.$route('kutipan.resit.ibayaq'))
        },

        BatalResit() {
            this.dialog.show = 1;
        },

        getAudit()  {
          var app = this;
              if(this.id){
                if(this.id > 0){
                  // this.$zcomm.get(this.ihasil +'terimaan_cek/'+this.id+''+window.location.search).then(res => {

                this.$zcomm.get(window.route('jejak_audit_resit_ibayaq',this.id)).then(res => {
                    this.audit = res;

                  });
                }
            }
        },

        janaJejakAudit(){
            this.$zcomm.update(window.route('simpan_jejak_audit_resit_ibayaq',this.form))
                      .then(res => {

                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit()
                          }
                          this.$inertia.visit(this.$page.url, { preserveScroll: true })
                      })
                      .catch(err => {

                      })
                      .finally(() => {
                          

                      });
        
        },
    
  },
  watch: {

  },
  mounted() {

    if(this.id == 0){
      this.form = {
        show: true,
        butiran : [{akaun_id : null, no_fail : null, keterangan : null, kuantiti : 1, kadar : null, amaun : null} ]}
      }

    this.getAudit();
    
      
  },
    
}
</script>